import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useContext, useEffect, useRef, useState } from 'react';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import './Header.css';
import { CustomCursorContext } from '../customCursor/context/CustomCursorContext';
import { MazeResultContext } from '../customCursor/context/MazeResult';
import axios from 'axios';

import Cookies from 'js-cookie';


gsap.registerPlugin(ScrollTrigger);
const url = process.env.REACT_APP_URL_LOCAL;
const Header = ({ scrollTo, setEasterEgg }) => {
	const { setTypeCursor } = useContext(CustomCursorContext);
	const { finalResult, mazeOneResult, mazeTwoResult, mazeThreeResult } = useContext(MazeResultContext);
	const [resultMaze, setResultMaze] = useState(0); // {mazeOneResult, mazeTwoResult, mazeThreeResult}

	const main = useRef();
	// useLayoutEffect(() => {
	// 	const ctx = gsap.context((self) => {
	// 		const navContainer = self.selector('.primary-nav-wrapper');
	// 		gsap.to(navContainer, {
	// 			scrollTrigger: {
	// 				trigger: navContainer,
	// 				start: '100px',
	// 				// markers: true,
	// 				end: '300px',
	// 				scrub: true,
	// 			},
	// 			opacity: 0.6,
	// 			borderBottomColor: 'white',
	// 		});
	// 	}, main);

	// 	return () => ctx.revert();
	// }, []);

	useEffect(() => {
		let result = 0;
		if (mazeOneResult) {
			if (mazeOneResult === process.env.REACT_APP_MAZE_ONE) result += 1;
		}
		if (mazeTwoResult) {
			if (mazeTwoResult === process.env.REACT_APP_MAZE_TWO) result += 1;
		}
		if (mazeThreeResult) {
			if (mazeThreeResult === process.env.REACT_APP_MAZE_THREE) result += 1;
		}
		setResultMaze(result);
		if (result === 3) {
			const fetchData = async () => {
				try {
					const body={finalResult}
					const response = await axios.post(url+'/maze-all-submission', body);
					console.log(response.data)
					if (response.data.success){
						Cookies.set('mazeToken', response.data.mazeToken)
						setEasterEgg(true);
					} else {
						console.log("forbidden")
					}
				} catch (error) {
					console.log(error.message)
				}
			};
			fetchData();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [finalResult]);

	useEffect(() => {
		gsap.to('.primary-nav-wrapper', {
			scrollTrigger: {
				trigger: '.primary-nav-wrapper',
				start: '100px',
				// markers: true,
				end: '300px',
				scrub: true,
			},
			opacity: 0.95,
			borderBottomColor: 'white',
		});
	}, []);
	return (
		<>
			<section ref={main}>
				<div className="primary-nav-wrapper">
					<div className="primary-nav-container">
						<nav
							// onMouseEnter={() => {
							// 	setTypeCursor('cursor-hover');
							// }}
							// onMouseLeave={() => {
							// 	setTypeCursor('default');
							// }}
							className="primary-nav"
						>
							<div
								// onMouseEnter={() => {
								// 	setTypeCursor('cursor-hover');
								// }}
								// onMouseLeave={() => {
								// 	setTypeCursor('default');
								// }}
								onMouseEnter={() => {
									setTypeCursor('cursor-hover');
								}}
								onMouseLeave={() => {
									setTypeCursor('default');
								}}
								onClick={() => {
									scrollTo('.about-section');
								}}
								className="primary-nav-button"
								data-text={'about'}
							>
								About
							</div>
							<div
								// onMouseEnter={() => {
								// 	setTypeCursor('cursor-hover');
								// }}
								// onMouseLeave={() => {
								// 	setTypeCursor('default');
								// }}
								onMouseEnter={() => {
									setTypeCursor('cursor-hover');
								}}
								onMouseLeave={() => {
									setTypeCursor('default');
								}}
								onClick={() => {
									scrollTo('.portfolio-section');
								}}
								className="primary-nav-button"
								data-text={'portfolio'}
							>
								PORTFOLIO
							</div>
							<div
								// onMouseEnter={() => {
								// 	setTypeCursor('cursor-hover');
								// }}
								// onMouseLeave={() => {
								// 	setTypeCursor('default');
								// }}
								onMouseEnter={() => {
									setTypeCursor('cursor-hover');
								}}
								onMouseLeave={() => {
									setTypeCursor('default');
								}}
								onClick={() => {
									scrollTo('.contact-section');
								}}
								className="primary-nav-button"
								data-text={'Contact'}
							>
								contact
							</div>
							{resultMaze !== 0 && (
								<>
									<div className="maze-progression-container">
										<div
											className="maze-progression"
											style={{ width: `${resultMaze * 33 * 0.95}%` }}
										></div>

										<div className="key-progression-icon">
											<VpnKeyIcon></VpnKeyIcon>
										</div>
										<div>{resultMaze}/3</div>
									</div>
								</>
							)}
						</nav>
					</div>
				</div>
			</section>
		</>
	);
};

export default Header;
